import { styled } from "@mui/material";

export const getModalStyle = (
  size: "small" | "medium" | "large" = "medium",
) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: size === "small" ? 480 : size === "medium" ? 680 : 920,
  width: "calc(100% - 80px)",
  bgcolor: "background.paper",
  maxHeight: "calc(100dvh - 80px)",
  display: "flex",
  flexDirection: "column",

  border: "none",
  borderRadius: "5px",
  boxShadow: "0px 4px 20px rgba(60, 133, 191, 0.18)",
  p: 4,
});

export const StyledText = styled("p")(() => ({
  fontSize: 24,
  fontWeight: "600",
  display: "flex",
  justifyContent: "left",
  margin: "8px 0",
}));
